export default "__VITE_ASSET__DwgBbmHT__"